import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import Help from 'src/ui/features/Help/Help';
import { updateBodyClass } from 'src/helpers';
import { HELP_URL, BODY_CLASSES } from 'src/constants/constants.js';
import { addToHistory } from 'src/utils/utilsActions';
import intl from 'react-intl-universal';

class HelpRoot extends Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.HELP);
    this.props.addToHistory(window.location.pathname);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.HELP);
  }

  render() {
    return (
      <Layout headerName={intl.get('help.pageTitle')}>
        <Switch>
          <Route path={HELP_URL} render={props => <Help {...props} />} />
        </Switch>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = {
  addToHistory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HelpRoot);
